import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UpcomingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"upcoming"}/>
}
